module.exports = __webpack_public_path__ + "static/google-play-eb2f25957b5cd178161c60408581826a.svg";